// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:21
import { TaskResource_abstract } from './../abstract/SagaSchema/TaskResource_abstract';
export class TaskResource extends TaskResource_abstract {}
